module.exports = __webpack_public_path__ + "static/digital_transformation-1569da6c08af67691f9eca18e7f366a0.svg";